/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './post-op-recovery-discharge.reducer';

export const PostOpRecoveryDischargeDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const postOpRecoveryDischargeEntity = useAppSelector(state => state.postOpRecoveryDischarge.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="postOpRecoveryDischargeDetailsHeading">
          <Translate contentKey="tinyMedicRestApp.postOpRecoveryDischarge.detail.title">PostOpRecoveryDischarge</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="tinyMedicRestApp.postOpRecoveryDischarge.id">Id</Translate>
            </span>
          </dt>
          <dd>{postOpRecoveryDischargeEntity.id}</dd>
          <dt>
            <span id="vitalsStable">
              <Translate contentKey="tinyMedicRestApp.postOpRecoveryDischarge.vitalsStable">Vitals Stable</Translate>
            </span>
          </dt>
          <dd>{postOpRecoveryDischargeEntity.vitalsStable ? 'true' : 'false'}</dd>
          <dt>
            <span id="patientAbleToWalk">
              <Translate contentKey="tinyMedicRestApp.postOpRecoveryDischarge.patientAbleToWalk">Patient Able To Walk</Translate>
            </span>
          </dt>
          <dd>{postOpRecoveryDischargeEntity.patientAbleToWalk}</dd>
          <dt>
            <span id="vomiting">
              <Translate contentKey="tinyMedicRestApp.postOpRecoveryDischarge.vomiting">Vomiting</Translate>
            </span>
          </dt>
          <dd>{postOpRecoveryDischargeEntity.vomiting ? 'true' : 'false'}</dd>
          <dt>
            <span id="bleeding">
              <Translate contentKey="tinyMedicRestApp.postOpRecoveryDischarge.bleeding">Bleeding</Translate>
            </span>
          </dt>
          <dd>{postOpRecoveryDischargeEntity.bleeding ? 'true' : 'false'}</dd>
          <dt>
            <span id="pain">
              <Translate contentKey="tinyMedicRestApp.postOpRecoveryDischarge.pain">Pain</Translate>
            </span>
          </dt>
          <dd>{postOpRecoveryDischargeEntity.pain}</dd>
          <dt>
            <span id="conditionAtDischarge">
              <Translate contentKey="tinyMedicRestApp.postOpRecoveryDischarge.conditionAtDischarge">Condition At Discharge</Translate>
            </span>
          </dt>
          <dd>{postOpRecoveryDischargeEntity.conditionAtDischarge}</dd>
          <dt>
            <span id="dischargeCriteria">
              <Translate contentKey="tinyMedicRestApp.postOpRecoveryDischarge.dischargeCriteria">Discharge Criteria</Translate>
            </span>
          </dt>
          <dd>{postOpRecoveryDischargeEntity.dischargeCriteria ? 'true' : 'false'}</dd>
          <dt>
            <span id="active">
              <Translate contentKey="tinyMedicRestApp.postOpRecoveryDischarge.active">Active</Translate>
            </span>
          </dt>
          <dd>{postOpRecoveryDischargeEntity.active ? 'true' : 'false'}</dd>
          <dt>
            <span id="cursor">
              <Translate contentKey="tinyMedicRestApp.postOpRecoveryDischarge.cursor">Cursor</Translate>
            </span>
          </dt>
          <dd>{postOpRecoveryDischargeEntity.cursor}</dd>
          <dt>
            <span id="lastupdated">
              <Translate contentKey="tinyMedicRestApp.postOpRecoveryDischarge.lastupdated">Lastupdated</Translate>
            </span>
          </dt>
          <dd>{postOpRecoveryDischargeEntity.lastupdated}</dd>
          <dt>
            <span id="microSec">
              <Translate contentKey="tinyMedicRestApp.postOpRecoveryDischarge.microSec">Micro Sec</Translate>
            </span>
          </dt>
          <dd>{postOpRecoveryDischargeEntity.microSec}</dd>
          <dt>
            <span id="timestampentry">
              <Translate contentKey="tinyMedicRestApp.postOpRecoveryDischarge.timestampentry">Timestampentry</Translate>
            </span>
          </dt>
          <dd>{postOpRecoveryDischargeEntity.timestampentry}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.postOpRecoveryDischarge.surgery">Surgery</Translate>
          </dt>
          <dd>{postOpRecoveryDischargeEntity.surgery ? postOpRecoveryDischargeEntity.surgery.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.postOpRecoveryDischarge.recoveryDoctor">Recovery Doctor</Translate>
          </dt>
          <dd>{postOpRecoveryDischargeEntity.recoveryDoctor ? postOpRecoveryDischargeEntity.recoveryDoctor.id : ''}</dd>
        </dl>
        <Button tag={Link} to="/post-op-recovery-discharge" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/post-op-recovery-discharge/${postOpRecoveryDischargeEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default PostOpRecoveryDischargeDetail;
